import useRouter from "@stadium/hooks/lib/use-custom-route";
import { useMemo } from "react";

import { getCanBuyProduct, getMasterVariant } from "@helpers/product-details";

import ByoCategory from "@components/store/product-detail/byo";
import Dsd from "@components/store/product-detail/dsd";
import GiftCard from "@components/store/product-detail/gift-card";
import Medley from "@components/store/product-detail/medley";
import Snacks from "@components/store/product-detail/snacks";
import Swag from "@components/store/product-detail/swag";
import ThemeBox from "@components/store/product-detail/theme-box";
import ProductInfoProvider from "@contexts/product-info-context";
import ScrollToTopOnMount from "@stadium/ui/src/components/scroll-to-top";
import { useProductDetailContext } from "@contexts/product-detail-context";

import {
  swagmagic,
  snacks,
  snacksKit,
  dsd,
  medley,
  themedBox,
  giftCard,
  byo,
} from "@constants/products/detail";

const ProductDetailIndex = ({ product, data }) => {
  const router = useRouter();
  const { variantId = "" } = router.query;
  const masterVariant = useMemo(() => getMasterVariant(product), [product]);
  const { renderAddedToBagModal } = useProductDetailContext();

  const canBuyProduct = getCanBuyProduct({ product });
  const canBuyParentProduct = data?.canBuyParentProduct;

  /*
   * When opened from a BYO product listing, canBuyParentProduct is passed explicitly so child
   * products inherit the parent purchasability. When omitted (main PDP and most modals), only
   * the child product's own canBuyProduct should apply.
   */
  const renderProduct = () => {
    const { intent } = product;
    const productProps = {
      product,
      masterVariant,
      canBuyProduct: canBuyProduct && (canBuyParentProduct ?? true),
      variantId,
    };
    switch (intent) {
      case medley:
        return <Medley {...productProps} />;
      case swagmagic:
        return <Swag {...productProps} />;
      case dsd:
        return <Dsd {...productProps} />;
      case snacks:
      case snacksKit:
        return <Snacks {...productProps} />;
      case themedBox:
        return <ThemeBox {...productProps} />;
      case giftCard:
        return <GiftCard {...productProps} />;
      case byo:
        return <ByoCategory {...productProps} />;
      default:
        return null;
    }
  };

  return (
    <ProductInfoProvider data={data}>
      <ScrollToTopOnMount />
      {renderProduct()}
      {renderAddedToBagModal()}
    </ProductInfoProvider>
  );
};

export default ProductDetailIndex;
